import React from "react";
import { useMutationBundle } from "source/hooks";
import { UpdateUserHoldings } from "$gql/mutations/general/UpdateUserHoldings.gen";
import { useFetchUser } from "source/hooks";

export const TriggerUpdate: React.FC<{}> = (props) => {
  const { user: currentUser } = useFetchUser();
  const [update] = useMutationBundle(UpdateUserHoldings);

  React.useEffect(() => {
    if (currentUser) {
      update({ variables: { userId: currentUser.id } });
    }
  }, [currentUser?.id]);

  return <></>;
};
